import { supabase } from '../lib/supabase';

// CRITICAL FIX: Get effective user ID for all queries
const getEffectiveUserId = () => {
  const impersonationData = localStorage.getItem('admin_impersonation');
  if (impersonationData) {
    const { impersonatedUserId } = JSON.parse(impersonationData);
    return impersonatedUserId;
  }
  return null;
};

export const bundlePricingService = {
  /**
   * Get all bundle pricing calculations for the authenticated user
   */
  async getAll() {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('bundle_pricing_calculations')?.select('*')?.eq('user_id', user?.id)?.order('created_at', { ascending: false })?.limit(20);

    if (error) throw error;

    return data?.map(row => ({
      id: row?.id,
      userId: row?.user_id,
      bundleName: row?.bundle_name,
      bundleDescription: row?.bundle_description,
      totalIndividualPrice: row?.total_individual_price,
      bundleDiscountPercentage: row?.bundle_discount_percentage,
      bundlePrice: row?.bundle_price,
      savingsAmount: row?.savings_amount,
      items: row?.items,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at,
    })) || [];
  },

  /**
   * Create a new bundle pricing calculation
   */
  async create(calculation) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('bundle_pricing_calculations')?.insert({
        user_id: user?.id,
        bundle_name: calculation?.bundleName,
        bundle_description: calculation?.bundleDescription,
        total_individual_price: calculation?.totalIndividualPrice,
        bundle_discount_percentage: calculation?.bundleDiscountPercentage,
        bundle_price: calculation?.bundlePrice,
        savings_amount: calculation?.savingsAmount,
        items: calculation?.items,
      })?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      userId: data?.user_id,
      bundleName: data?.bundle_name,
      bundleDescription: data?.bundle_description,
      totalIndividualPrice: data?.total_individual_price,
      bundleDiscountPercentage: data?.bundle_discount_percentage,
      bundlePrice: data?.bundle_price,
      savingsAmount: data?.savings_amount,
      items: data?.items,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
    };
  },

  /**
   * Update an existing bundle calculation
   */
  async update(id, calculation) {
    const { data, error } = await supabase?.from('bundle_pricing_calculations')?.update({
        bundle_name: calculation?.bundleName,
        bundle_description: calculation?.bundleDescription,
        total_individual_price: calculation?.totalIndividualPrice,
        bundle_discount_percentage: calculation?.bundleDiscountPercentage,
        bundle_price: calculation?.bundlePrice,
        savings_amount: calculation?.savingsAmount,
        items: calculation?.items,
      })?.eq('id', id)?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      userId: data?.user_id,
      bundleName: data?.bundle_name,
      bundleDescription: data?.bundle_description,
      totalIndividualPrice: data?.total_individual_price,
      bundleDiscountPercentage: data?.bundle_discount_percentage,
      bundlePrice: data?.bundle_price,
      savingsAmount: data?.savings_amount,
      items: data?.items,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
    };
  },

  /**
   * Delete a calculation
   */
  async delete(id) {
    const { error } = await supabase?.from('bundle_pricing_calculations')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  /**
   * Delete all calculations for the authenticated user
   */
  async deleteAll() {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase?.from('bundle_pricing_calculations')?.delete()?.eq('user_id', user?.id);

    if (error) throw error;
  },
};